import React from "react";
import { css } from "@emotion/react";

import components from "elements/config/components";
import ProductList from "pages/Components/ProductListPage/components/ProductList";
import theme from "theme/index";

type Props = {
    data: ProductListPage,
};

const ProductListPage: React.FC<Props> = ({ data }) => {
    const bannerWithFullImageStyle = css`
        .banner-with-full-image--wrapper {
            height: 255px;

            ${theme.breakpoints.down('xs')} {
                height: 165px;
            }
        }
    `;

    return (
        <>
            {data?.elements && data.elements.map((ele: any, index: number) => {
                if (ele.__typename !== 'ProductListItem') {
                    let Component = Object.prototype.hasOwnProperty.call(components, ele.__typename) && components[ele.__typename]
                    return (
                        <Component
                            data={ele}
                            key={`${ele.id}-${index}`}
                            {...ele.__typename === "BannerWithFullImage" && {
                                css: bannerWithFullImageStyle
                            }}
                        />
                    );
                }
                return <ProductList page={data} key={`${ele.id}-${index}`} />
            })}
        </>
    );
};

export default ProductListPage;